import { Box, Typography } from '@mui/material';
import { CircularLoading, COOKIE_NAME } from '@myhrbox/myhrbox-frontend-core';
import AssesmentAccessCard, { MessageVariant } from 'components/AssesmentAccessCard';
import client from 'config/apolloConfig';
import useIsExaminationActive from 'hooks/useIsExaminationActive';
import cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { $user, userLogout } from 'store/user/model';
import ExaminationRegisterForm from './ExaminationRegisterForm';

const ExaminationRegister = () => {
  const { t } = useTranslation();
  const { isExaminationActive, loading, examinationId, error } = useIsExaminationActive();
  const [showAssesmentAccessCard, setShowAssesmentAccessCard] = useState(false);

  const logout = () => {
    localStorage.clear();

    cookies.remove(COOKIE_NAME.ACCESS_TOKEN);
    cookies.remove(COOKIE_NAME.REFRESH_TOKEN);

    userLogout();
    $user.watch((state) => {
      if (state === null) {
        client.resetStore();
      }
    });
  };

  useEffect(() => {
    if (examinationId) {
      logout();
    }
  }, []);

  if (loading || isExaminationActive === undefined) return <CircularLoading />;

  if (!isExaminationActive || showAssesmentAccessCard)
    return (
      <AssesmentAccessCard messageVariant={error ? MessageVariant.ERROR : MessageVariant.ACCESS} />
    );

  return (
    <Box>
      <Typography variant='h28' sx={{ mb: 4 }}>
        {t('register.title')}
      </Typography>
      <ExaminationRegisterForm
        examinationId={examinationId!}
        setShowAssesmentAccessCard={setShowAssesmentAccessCard}
      />
    </Box>
  );
};

export default ExaminationRegister;
